<template>
  <section id="pdf">
    <div class="comprobante" v-if="datosNegocio">
      <div class="header">
        <div class="logo-container">
          <img :src="logoUrl" class="logo" />
        </div>
        <div class="empresa-info">
          <h1>{{ nombre }}</h1>
        </div>
      </div>
      <p>Teléfono: {{ telefono }}</p>
      <p><b>Fecha: </b>{{ abono.fecha }}</p>

      <div class="parrafo">
        <p>
          El día <b>{{ fecha }}</b> el cliente <b>{{ cuenta.nombreCliente }}</b>, realizó un abono por un monto de
          <span v-if="abono.montoBs">
            <b>Bs. {{ formatoMonto(abono.montoBs) }}</b>
            <b> a una tasa de Bs. {{ (abono.montoBs / abono.monto).toFixed(2) }}</b>
            <b> equivalente a ${{ formatoMonto(abono.monto) }}</b>
          </span>
          <span v-else>
            <b>${{ formatoMonto(abono.monto) }}</b>
          </span>,
          tras lo cual su monto restante es de
          <b>${{ formatoMonto(cuenta.porPagar) }}</b>.
        </p>
      </div>

      <div class="firmas">
        <div>
          <p>_________________________</p>
          <p>Firma del cliente</p>
        </div>
        <div>
          <p>_________________________</p>
          <p>Firma del dueño</p>
        </div>
      </div>

      <p><b>Gracias por su preferencia</b></p>
      <p>----------------------------</p>
    </div>
  </section>
</template>

<script>
import Printd from 'printd'
import Utiles from '@/Servicios/Utiles'
import jiroLogo from '@/assets/jirosushi.png'
import primeLogo from '@/assets/FoodPrime.jpeg'
import ccsLogo from '@/assets/ofertacaracas.jpg'

export default {
  name: 'PDFAbono',

  data: () => ({
    titulo: '',
    cuenta: null,
    abono: null,
    nombre: '',
    telefono: '',
    logoUrl: '',
    datosNegocio: true,
  }),

  methods: {
    formatoMonto (valor)
    {
      return Utiles.formatoMonto(valor)
    }
  },

  async mounted ()
  {
    const { VUE_APP_OWNER_PHONE } = process.env
    this.telefono = VUE_APP_OWNER_PHONE
    document.body.style.opacity = '0'

    const json = localStorage.getItem('comprobante-abono')
    const { cuenta, abono, local } = JSON.parse(json)
    this.cuenta = cuenta
    this.abono = abono
    localStorage.removeItem('comprobante-abono')

    // Set business name and logo based on local
    switch (local) {
      case 'ccs':
        this.nombre = 'Oferta Caracas'
        this.logoUrl = ccsLogo
        break
      case 'prime':
        this.nombre = 'Food Prime'
        this.logoUrl = primeLogo
        break
      default:
        this.nombre = 'Jirosushi Prime'
        this.logoUrl = jiroLogo
    }

    const d = new Printd()
    d.onAfterPrint(() => window.close())

    new Promise(res => setTimeout(res, 1000))
      .then(() =>
      {
        const comprobante = document.querySelector('#pdf')
        d.print(comprobante, [`
          h1 {
            text-align: center;
          }

          .comprobante {
            font-size: 22px;
            font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
          }

          .comprobante p {
            margin: 0;
            padding: 0;
            text-align: center;
          }

          .comprobante img {
            display: block;
            margin: 0 auto;
          }

          .parrafo {
            margin-top: 2rem;
            display: block;
          }

          .firmas {
            display: flex;
            justify-content: space-around;
            margin-top: 3rem;
            margin-bottom: 3rem;
          }
        `])
      })
  },

  computed: {
    fecha ()
    {
      return new Intl.DateTimeFormat('es', {
        dateStyle: 'long',
      }).format(new Date(this.abono.fecha))
    },
  }
}
</script>
